import React from "react";
export default function Heading() {
    return <>
        <h1>
            <img alt="Expensinator" src="../money-bag.png" height={"60px"} width={"60px"} />
              Expensinator!!</h1>
        <h2> The Gen-Z expense tracker!!</h2>
    </>
}